import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-svt-bg transition-colors duration-300" data-id="element-78">
      <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-79"></div>
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-svt-bg/80 to-svt-bg pointer-events-none" data-id="element-80"></div>

      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-30" data-id="element-81">
        <motion.div animate={{
        scale: [1, 1.05, 1],
        opacity: [0.5, 0.8, 0.5],
        rotate: [0, 5, 0]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute" data-id="element-82">
          <svg width="600" height="600" viewBox="0 0 24 24" fill="url(#grad1)" xmlns="http://www.w3.org/2000/svg" className="blur-3xl" data-id="element-83">
            <defs data-id="element-84">
              <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-85">
                <stop offset="0%" stopColor="#e84393" data-id="element-86" />
                <stop offset="100%" stopColor="#a855f7" data-id="element-87" />
              </linearGradient>
            </defs>
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" data-id="element-88" />
          </svg>
        </motion.div>
        <motion.div animate={{
        scale: [1.1, 1, 1.1],
        opacity: [0.3, 0.6, 0.3],
        rotate: [0, -5, 0]
      }} transition={{
        duration: 12,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute ml-40 mt-32" data-id="element-89">
          <svg width="400" height="400" viewBox="0 0 24 24" fill="url(#grad2)" xmlns="http://www.w3.org/2000/svg" className="blur-2xl" data-id="element-90">
            <defs data-id="element-91">
              <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-92">
                <stop offset="0%" stopColor="#a855f7" data-id="element-93" />
                <stop offset="100%" stopColor="#e84393" data-id="element-94" />
              </linearGradient>
            </defs>
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" data-id="element-95" />
          </svg>
        </motion.div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center flex flex-col items-center" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8 inline-flex items-center gap-2 px-5 py-2 rounded-full border border-svt-pink/30 bg-svt-pink/5 backdrop-blur-md shadow-[0_0_20px_rgba(232,67,147,0.15)]" data-id="element-97">
          <span className="w-2 h-2 rounded-full bg-svt-pink animate-pulse" data-id="element-98"></span>
          <span className="text-svt-pink-light text-xs font-bold tracking-widest uppercase" data-id="element-99">
            {t('hero.badge')}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-4xl md:text-5xl lg:text-6xl font-black mb-6 leading-[1.1] tracking-tight text-svt-text" data-id="element-100">
          {t('hero.title1')}
          {t('hero.title2') && <>
              <br data-id="element-101" />
              {t('hero.title2')}
            </>}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-svt-text-secondary mb-12 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-102">
          {t('hero.subtitle')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto" data-id="element-103">
          <button className="px-10 py-4 rounded-full bg-gradient-primary text-white font-bold text-lg hover:opacity-90 transition-all shadow-[0_0_30px_rgba(232,67,147,0.4)] hover:shadow-[0_0_50px_rgba(232,67,147,0.6)] transform hover:-translate-y-1" data-id="element-104">
            {t('hero.cta1')}
          </button>
          <button className="px-10 py-4 rounded-full border border-svt-border-hover text-svt-text font-medium text-lg hover:bg-svt-surface-hover transition-all transform hover:-translate-y-1 backdrop-blur-sm" data-id="element-105">
            {t('hero.cta2')}
          </button>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-svt-pink/30 to-transparent" data-id="element-106"></div>
    </section>;
}